import { useAdvancedCareProviderSearchFiltersQuery$data } from "@/modules/care-provider/advanced-search/services/__generated__/useAdvancedCareProviderSearchFiltersQuery.graphql"
import { ArrElement } from "@/types/ArrElement"

export type AdvancedCareProviderFilterType =
  | keyof Pick<
      useAdvancedCareProviderSearchFiltersQuery$data,
      "careProviderGroups" | "cantons" | "officialLanguages" | "diagnosticFacilities" | "certificates"
    >
  | "services"
  | "specialties"
  | "foci"
  | "specializations"
  | "subjectAreas"
  | "isWalkIn"
  | "isTakesNewPatients"
  | "isMedgatePartnerNetworkMember"
  | "isInsurerNetworkMember"
  | "features"

export type AdvancedCareProviderFilterMenuConfig = {
  label: string
  type: "multipleSelect" | "singleSelect" | "booleanSelect"
  isSearchable?: boolean
  analyticsSuffixKey?: string
}

export type OfficialLanguage = ArrElement<useAdvancedCareProviderSearchFiltersQuery$data["officialLanguages"]>

type CareProviderGroups = NonNullable<useAdvancedCareProviderSearchFiltersQuery$data["careProviderGroups"]>["items"]

type CareProviderGroupItem = ArrElement<CareProviderGroups>

export const FEATURES = [
  "isHandleAdultEmergency",
  "isHandleChildEmergency",
  "isHomeTreatment",
  "isTelemedicine",
  "isWheelchairAccessible",
] as const

export type FeatureId = (typeof FEATURES)[number]

export type FEATURE = { id: FeatureId; name: string }

export type AdvancedCareProviderFilter = {
  careProviderGroups: NonNullable<CareProviderGroups>
  specialties: CareProviderGroupItem["specialties"]
  foci: ArrElement<CareProviderGroupItem["specialties"]>["foci"]
  specializations: ArrElement<CareProviderGroupItem["specialties"]>["specializations"]
  subjectAreas: CareProviderGroupItem["subjectAreas"]
  services: CareProviderGroupItem["services"]
  cantons: useAdvancedCareProviderSearchFiltersQuery$data["cantons"]

  features: FEATURE[]
  certificates: useAdvancedCareProviderSearchFiltersQuery$data["certificates"]
  diagnosticFacilities: useAdvancedCareProviderSearchFiltersQuery$data["diagnosticFacilities"]
  officialLanguages: useAdvancedCareProviderSearchFiltersQuery$data["officialLanguages"]
}

export type FilterSelectValues = {
  id: string
  name: string
  groupType?: string
  cantonCode?: string
}

export type FormattedAdvancedCareProviderFilterValues = {
  careProviderGroups: FilterSelectValues
  specialties: FilterSelectValues
  foci: FilterSelectValues
  specializations: FilterSelectValues
  subjectAreas: FilterSelectValues
  services: FilterSelectValues
  cantons: FilterSelectValues

  features: FEATURE[]
  certificates: FilterSelectValues[]
  diagnosticFacilities: FilterSelectValues[]
  officialLanguages: FilterSelectValues[]

  isMedgatePartnerNetworkMember: boolean
  isInsurerNetworkMember: boolean
  isWalkIn: boolean
  isTakesNewPatients: boolean
}
